module.exports = __webpack_public_path__ + "assets/media/welcome-video.b0905a78.mp4";